/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import Notiflix from 'notiflix';
import Modal2 from '../../components/Modal2';
import { Button } from '../Tutorials/styles';
import Input from '../../components/Input';
import { HolderContentStyled, ModalFormWrapper, Table } from './styles';
import { Column } from '../../components/Table';
import { Row } from './interface';
import api from '../../services/api/api';
import SelectUnform from '../../components/SelectUnform';
import { useAuth } from '../../hooks/auth';
import { getTag } from '../../utils/tableUtils';

interface ValidHolder {
  holderId: number;
  cardId: any;
  status: string;
  beneficiaryName: string;
  statusId: string;
}

interface ValidHoldersOutput {
  result: number;
  message: string;
  data: ValidHolder[];
}

interface HoldersStatusOutput {
  content: {
    status: {
      statusCode: string;
      status: string;
    }[];
  }[];
}

interface HolderModalContentProps {
  data: Row;
  handleConfirm: (callback: () => Promise<boolean>) => void;
  getDataToTable: (filter?: any) => void;
}

export const ConfirmModalContent = ({
  callback,
  handleOpenSuccessModal,
}: {
  callback: () => Promise<boolean>;
  handleOpenSuccessModal: () => void;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Button
        modal
        onClick={async () => {
          try {
            const response = await callback();

            if (response) {
              Modal2.Close();
              handleOpenSuccessModal();
            }
          } catch (error) {
            Notiflix.Notify.failure(
              'Ocorreu um erro ao realizar a troca de titular.',
              {
                zindex: 999999999999,
              },
            );
          }
        }}
        style={{ backgroundColor: '#0a5f55', color: '#fff' }}
      >
        Confirmar
      </Button>

      <Button
        secondary
        modal
        onClick={() => Modal2.Close()}
        style={{
          backgroundColor: 'transparent',
          border: '1px solid #676767',
        }}
      >
        Cancelar
      </Button>
    </div>
  );
};

const HolderModalContent = ({
  data,
  handleConfirm,
  getDataToTable,
}: HolderModalContentProps) => {
  const formRef = useRef<FormHandles>(null);
  const [status, setStatus] = useState<
    {
      id: string;
      name: string;
    }[]
  >([]);
  const [validHoldersPanel, setValidHoldersPanel] = useState<ValidHolder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<ValidHolder | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const { user } = useAuth();

  const handleSelectHolder = () => {
    if (!selectedData) {
      return Notiflix.Notify.failure(
        'Por favor, selecione um beneficiário para continuar.',
        {
          zindex: 999999999999,
        },
      );
    }

    handleConfirm(async () => {
      const controller = new AbortController();
      try {
        setIsLoading(true);

        await api.put(
          '/company/change-holder',
          {
            holderId: selectedData.holderId,
            contractId: user.contractId,
            requestId: data.requestId,
          },
          { signal: controller.signal },
        );

        getDataToTable();
        return true;
      } catch (error: any) {
        if (error.name !== 'CanceledError') {
          console.error('Error during holder selection:', error);
          Notiflix.Notify.failure(
            'Ocorreu um erro ao realizar a troca de titular.',
            {
              zindex: 999999999999,
            },
          );
        }
        return false;
      } finally {
        setIsLoading(false);
      }
    });
  };

  const handleFilterHolders = useCallback(
    async (formData: Record<string, string>) => {
      const controller = new AbortController();
      setIsLoading(true);

      try {
        const queryParams = new URLSearchParams();
        if (formData.statusCode)
          queryParams.append('statusCode', formData.statusCode.trim());
        if (formData.cardCode)
          queryParams.append('cardCode', formData.cardCode.trim());
        if (formData.holderName)
          queryParams.append('holderName', formData.holderName.trim());
        if (formData.page) {
          queryParams.append('page', formData.page);
        }
        const contractId = user.contractId || '';

        queryParams.append('contractId', contractId);

        const response = await api.get<ValidHoldersOutput>(
          `/beneficiary-dependent-holder/list-probable-holder?${queryParams.toString()}`,
          { signal: controller.signal },
        );

        setValidHoldersPanel((prevHolders) =>
          formData.page && Number(formData.page) > 1
            ? [...prevHolders, ...response.data.data]
            : response.data.data,
        );

        setCurrentPage(Number(formData.page ?? 1));
        setHasMoreData(response.data.data.length === 10);
      } catch (err: unknown) {
        if (
          typeof err === 'object' &&
          err !== null &&
          'name' in err &&
          (err as { name: string }).name !== 'CanceledError'
        ) {
          console.error(err);
        }
      } finally {
        setIsLoading(false);
      }

      return () => controller.abort();
    },
    [],
  );

  const handleLoadMore = useCallback(() => {
    if (isLoading || !hasMoreData) return;

    const currentSearch = formRef.current?.getData();

    handleFilterHolders({
      ...currentSearch,
      page: String(currentPage + 1),
    });
  }, [handleFilterHolders, currentPage, hasMoreData, isLoading]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchStatus = async () => {
      try {
        const response = await api.get<HoldersStatusOutput>(
          '/company/status-holders-panel',
          { signal: controller.signal },
        );

        const statusList = response.data.content.flatMap((item) =>
          item.status.map((s) => ({
            id: s.statusCode,
            name: s.status,
          })),
        );

        setStatus(statusList);
      } catch (error: any) {
        if (error.name !== 'CanceledError') {
          console.error('Error fetching status list:', error);
        }
      }
    };

    fetchStatus();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    formRef.current?.submitForm();
  }, []);

  const handleClearForm = () => {
    formRef.current?.reset();
    formRef.current?.setFieldValue('statusCode', '');
    setSelectedData(null);
  };

  return (
    <HolderContentStyled>
      <h3>Dependente: {data.beneficiaryName}</h3>

      <ModalFormWrapper
        onSubmit={handleFilterHolders}
        ref={formRef}
        className="form-change-holder"
      >
        <div className="form-group-content">
          <div className="form-group">
            <SelectUnform options={status} title="Status" name="statusCode" />

            <Input
              name="cardCode"
              label="Carteirinha"
              placeholder="Número da carteirinha"
            />

            <Button
              type="button"
              modal
              disabled={isLoading}
              onClick={() => formRef.current?.submitForm()}
              style={{ backgroundColor: '#0a5f55', color: '#fff' }}
            >
              Consultar
            </Button>
          </div>

          <div className="form-group">
            <Input
              name="holderName"
              label="Beneficiário"
              placeholder="Nome do beneficiário"
            />

            <Button secondary disabled={isLoading} onClick={handleClearForm}>
              Limpar
            </Button>
          </div>
        </div>

        <div className="table-container">
          <Table
            loading={isLoading}
            items={validHoldersPanel}
            selection={selectedData}
            disableRows
            callbackShowMore={handleLoadMore}
            maxItems={hasMoreData ? 999999 : validHoldersPanel.length}
            onSelectionChange={(e) => {
              if (
                e.originalEvent.currentTarget.classList.contains('p-checkbox')
              ) {
                const row = e.value[0];

                setSelectedData(row);
              }
            }}
            onRowClick={(e) => {
              const row = e.data;
              setSelectedData(row);
            }}
          >
            <Column selectionMode="single" headerStyle={{ width: '50px' }} />
            <Column header="Solicitação" field="holderId" />
            <Column header="Carteirinha" field="cardCode" />
            <Column header="Titular" field="beneficiaryName" />
            <Column
              header="Situação"
              field="status"
              body={(data: Record<string, string>) => {
                switch (data.status) {
                  case 'Aguardando análise da Operadora':
                  case 'Aguardando análise Operadora':
                    return getTag(
                      'Status',
                      'Aguard. Análi. Operadora',
                      'orange',
                      data.status,
                    );
                  case 'Aguardando liberação':
                    return getTag(
                      'Status',
                      'Aguard. Liberação',
                      'orange',
                      data.status,
                    );
                  case 'Contratação concluída':
                    return getTag(
                      'Status',
                      'Contrat. Cocluída',
                      'green',
                      data.status,
                    );
                  case 'Em processo de finalização':
                    return getTag(
                      'Status',
                      'Em Proces. Finalização',
                      'orange',
                      data.status,
                    );
                  case 'Solicitação com inconsistência':
                    return getTag(
                      'Status',
                      'Solic. c/ Inconsistência',
                      'orange',
                      data.status,
                    );
                  case 'Solicitação em andamento':
                    return getTag(
                      'Status',
                      'Solic. Em Andamento',
                      'orange',
                      data.status,
                    );
                  case 'Solicitação rejeitada pela operadora':
                    return getTag(
                      'Status',
                      'Solic. Rejeitada',
                      'red',
                      data.status,
                    );
                  case 'Aguardando Análise da Declaração de Saúde':
                    return getTag(
                      'Status',
                      'Aguard. Análi. Declar. Saúde',
                      'orange',
                      data.status,
                    );
                  case 'Solicitação cancelada':
                    return getTag(
                      'Status',
                      'Solicitação Cancelada',
                      'gray',
                      data.status,
                    );
                  case 'Aguardando preenchimento do Funcionário':
                    return getTag(
                      'Status',
                      'Aguard. Preench. Func.',
                      'orange',
                      data.status,
                    );
                  case 'Ativo':
                    return getTag('Status', 'Ativo', 'green', data.status);
                  default:
                    return getTag('Status', data.status, 'red', data.status);
                }
              }}
            />
          </Table>
        </div>
      </ModalFormWrapper>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1rem',
          gap: '1rem',
        }}
      >
        <Button
          modal
          onClick={handleSelectHolder}
          disabled={!selectedData}
          style={{ backgroundColor: '#0a5f55', color: '#fff' }}
        >
          Confirmar
        </Button>
        <Button
          secondary
          modal
          onClick={Modal2.Close}
          style={{
            backgroundColor: 'transparent',
            border: '1px solid #676767',
          }}
        >
          Cancelar
        </Button>
      </div>
    </HolderContentStyled>
  );
};

export const useHandleOpenHolderModal = (
  getDataToTable: (filter: any) => void,
) => {
  const handleOpenSuccessModal = useCallback(() => {
    Modal2.Success({
      closable: false,
      autoWidth: true,
      title: 'Perfeito!',
      text: 'Troca realizada com sucesso!',
      children: (
        <Button
          modal
          style={{ backgroundColor: '#0a5f55', color: '#fff' }}
          onClick={() => Modal2.Close()}
        >
          Ok
        </Button>
      ),
    });
  }, []);

  const handleConfirm = useCallback(
    (callback: () => Promise<boolean>) => {
      Modal2.Warning({
        closable: false,
        autoWidth: true,
        title: 'Confirmação de troca de Titular!',
        text: 'O dependente selecionado será migrado para outro titular',
        children: (
          <ConfirmModalContent
            callback={callback}
            handleOpenSuccessModal={handleOpenSuccessModal}
          />
        ),
      });
    },
    [handleOpenSuccessModal],
  );

  const handleOpenHolderModal = (data: Row): void => {
    Modal2.Generic({
      closable: false,
      children: (
        <HolderModalContent
          data={data}
          handleConfirm={handleConfirm}
          getDataToTable={getDataToTable}
        />
      ),
    });
  };

  return { handleOpenHolderModal };
};
